<script>
    import GC250 from "./templates/GC250.svelte";
    import GC315 from "./templates/GC315.svelte";
    import GC400 from "./templates/GC400.svelte";
    import GC400Mains from "./templates/GC400Mains.svelte";
    import HS315 from "./templates/HS315.svelte";

    import { settings } from "src/settings.store";
    import logoMeccalte from "images/logo-meccalte.svg";

    export let iconPath = '';

    let template;
    let templates = [{
        name: "gc250",
        component: GC250
    }, {
        name: "gc315",
        component: GC315
    }, {
        name: "gc400",
        component: GC400
    }, {
        name: "gc400-mains",
        component: GC400Mains
    }, {
        name: "hs315",
        component: HS315
    }];

    $: if ($settings.boardType) {
        template = templates.find(item => item.name == $settings.boardType);
    }

    const container = { width: 0, height: 0 }, content = { width: 0, height: 0 };
    $: scale = Math.min((container.width - 310) / content.width, container.height / content.height);

    $: iconPathFull = [iconPath, $settings.iconTheme, $settings.iconSet].join('/');
</script>

<div class="pc__preview" bind:clientHeight={container.height} bind:clientWidth={container.width}>
    <div class="pc__preview__template">
        {#if template}
        <div class="pc__template pc__template--{$settings.boardType} icons--{$settings.iconSet}"
            style="transform: scale({scale < 1 ? scale : 1}); --foreground: {$settings.foreground}; --background: {$settings.background}; --product-name-color: {$settings.productNameColor};"
            bind:clientHeight={content.height} bind:clientWidth={content.width}>
            <div class="pc__template__inner border--{$settings.border}">
                {#if $settings.logoMeccalte || !$settings.logo}
                <div class="pc__template__logo pc__template__logo--meccalte logo-position--top-left logo-dimension--{$settings.logoDimension}">{@html logoMeccalte}</div>
                {/if}
                {#if $settings.logo}
                <div class="pc__template__logo logo-position--{$settings.logoPosition}"><img src={URL.createObjectURL($settings.logo)} alt="Customer logo" /></div>
                {/if}
                {#if $settings.productName !== ""}
                <div class="pc__template__product-name logo-position--top-right">{$settings.productName}</div>
                {/if}
                <div class="pc__template__display border--{$settings.borderDisplay ? "single" : "none"}">
                    <div class="pc__template__display__background"></div>
                </div>
                <svelte:component this={template.component} iconPath={iconPathFull} {...$settings} />
            </div>
        </div>
        {/if}
    </div>
</div>